<template src="./AfiliacionWizard.html"></template>

<script>
import {Breadcrumb, BreadcrumbItem, Step, Steps} from 'element-ui'
import {mapState} from 'vuex'
import {requestAfiliacionMixin} from "@/api/ciudadano/afiliacionApi";
import PantallaInicio from "@/components/Ciudadano/Afiliacion/PantallaInicio/PantallaInicio";
import AfiliacionForm from "@/components/Ciudadano/Afiliacion/AfiliacionForm/AfiliacionForm";
import AfiliacionExitosa from "@/components/Ciudadano/Afiliacion/AfiliacionExitosa/AfiliacionExitosa";
import ValidacionNoExitosa from "@/components/Ciudadano/Afiliacion/ValidacionNoExitosa/ValidacionNoExitosa";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import {NotifyMixin} from "@/mixins/NotifyMixin";
import {RouterMixin} from "@/mixins/routerMixin";

export default {
  name: "AfiliacionWizard",
  components: {
    PantallaInicio,
    AfiliacionForm,
    AfiliacionExitosa,
    ValidacionNoExitosa,
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    [Steps.name]: Steps,
    [Step.name]: Step,
  },
  mixins: [
    requestAfiliacionMixin,
    ScreenSizeMixin,
    NotifyMixin,
    RouterMixin
  ],
  data() {
    return {
      afiliacionPendiente: false,
      partidoSelecionado: '',
      loading: false,
      active: 0
    }
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
  },
  methods: {
    onValidation(status) {
      this.$log.debug(status)
      this.afiliacionPendiente = status
      this.active++
    },
    onPantallaInicio() {
      this.active = 0
    },
    onCreated(valid, partidoSelecionado, isCreated) {
      this.$log.debug(valid, partidoSelecionado, isCreated)
      if (isCreated && valid) {
        this.partidoSelecionado = partidoSelecionado
        this.active++
      }
    },
  }
}
</script>


